import React, { ReactNode } from "react";

import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import noData from "@app/assets/map/no-data.svg";

import styles from "./NoData.module.scss";

const messages = defineMessages({
  clearFilters: {
    id: "recordList.noResults.clearFilters",
    defaultMessage: "Clear Filters",
    description: "Record List Clear Filters button title",
  },
  noEntityTypesSelected: {
    id: "recordList.noResults.noEntityTypesSelected",
    defaultMessage:
      "You have turned off all pins. Please re-enable Companies, People, or Deals to see results.",
    description: "Record List no Entity Types Selected description",
  },
  noEntityTypesSelectedAction: {
    id: "recordList.noResults.noEntityTypesSelectedAction",
    defaultMessage:
      "You have turned off all pins. Please re-enable Companies, People, or Deals to see results.",
    description: "Show All Pins",
  },
  text: {
    id: "recordList.noResults.description",
    defaultMessage:
      "You may be zoomed into a part of the map with no pins, or you may have too many filters applied.",
    description: "Record List no results description",
  },
  title: {
    id: "recordList.noResults.title",
    defaultMessage: "No results",
    description: "Record List no results title",
  },
});

interface Props {
  actionTitle?: ReactNode;
  hasRecords: boolean;
  onAction?: () => void;
  showAction?: boolean;
  showText?: boolean;
  showTitle?: boolean;
  text?: ReactNode;
  title?: ReactNode;
}

const NoData = ({
  actionTitle,
  hasRecords,
  onAction,
  showAction = true,
  showText = true,
  showTitle = true,
  text,
  title,
}: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <img alt="no results banner" src={noData} />
      </div>

      {showTitle && (
        <div className={styles.title}>{title ?? intl.formatMessage(messages.title)}</div>
      )}

      {showText && <div className={styles.empty}>{text ?? intl.formatMessage(messages.text)}</div>}

      {hasRecords && showAction && (
        <div className={styles.clearAction}>
          <Button onClick={onAction}>
            {actionTitle ?? intl.formatMessage(messages.clearFilters)}
          </Button>
        </div>
      )}
    </div>
  );
};

export default NoData;
